<template>
  <div class="breadcrumb">
    <el-breadcrumb :separator-icon="ArrowRight" class="flex-container align-center">
      <div>
        <el-breadcrumb-item :to="{ path: path }">{{ name }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ routeName }}</el-breadcrumb-item>
      </div>
      <div class="flex-grow-1"></div>
      <div v-if="!isWebhook">
        <el-button
          v-if="isTool"
          type="success"
          @click="handleApiTestTool">
          API Test Tool
        </el-button>
      </div>
      <div v-else>
        <el-button
          v-if="isTool"
          type="success"
          @click="handleApiWebhook">
          API Test Tool
        </el-button>
      </div>
    </el-breadcrumb>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ArrowRight } from '@element-plus/icons-vue'

const props = defineProps({
  path: {
    required: true,
    type: String,
    default: ''
  },
  name: {
    required: true,
    type: String,
    default: ''
  },
  routeName: {
    required: false,
    type: String,
    default: ''
  },
  isTool: {
    required: false,
    type: Boolean,
    default: false
  },
  isWebhook: {
    required: false,
    type: Boolean,
    default: false
  },
  dataWebhook: {
    required: false,
    type: Object,
    default: () => Object()
  }
})

const store = useStore()
const router = useRouter()
const handleApiTestTool = () => {
  router.push({
    path: '/api-test-tool',
    query: { name: props.routeName }
  })
}
const handleApiWebhook = () => {
  if (store.getters['app/tokenOlsera']) {
    store.dispatch('app/dataWebhook', props.dataWebhook)
    router.push({
      path: '/api-webhook-tool',
      query: {
        name: props.routeName
      }
    })
  } else {
    router.push({
      path: '/console/login-app'
    })
  }
}
</script>
